<template>
  <app-side-menu
    :min-width="18"
    :fixed-menu="false">
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                placeholder="First Name"
                v-model="filter.firstName"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                placeholder="Last Name"
                v-model="filter.lastName"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="filter.contactType">
                  <option value="">
                    All
                  </option>
                  <option
                    v-for="(a, b) in assetTypes"
                    :key="b"
                    :value="a">{{ b }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field has-addons">
            <bulma-radio-button
              :native-value="2"
              v-model="filter.active">
              <span class="icon is-small">
                <i class="mdi mdi-adjust" />
              </span> Both
            </bulma-radio-button>
            <bulma-radio-button
              type="is-success"
              :native-value="1"
              v-model="filter.active">
              <span class="icon is-small">
                <i class="mdi mdi-check" />
              </span> Active
            </bulma-radio-button>
            <bulma-radio-button
              type="is-danger"
              :native-value="0"
              v-model="filter.active">
              <span class="icon is-small">
                <i class="mdi mdi-close" />
              </span> In-Active
            </bulma-radio-button>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button
            class="button is-primary"
            @click="onFilterClick">
            <span class="icon is-small">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button
            class="button"
            @click="onResetClick">
            <span class="icon is-small">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AssetTypes from '@/enums/AssetTypes'
import AppSideMenu from '@/components/AppSideMenu'
import { BulmaRadioButton } from '@/components/BulmaRadio'

export default {
  name: 'ContactListSideMenu',
  components: {
    AppSideMenu,
    BulmaRadioButton
  },
  props: {
    filter: null
  },
  data() {
    return {
      selectedActive: 1,
      stateList: null
    }
  },
  computed: {
    assetTypes: function() {
      return AssetTypes
    }
  },
  created() {},
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.$emit('reset')
    }
  }
}
</script>
